import type { AppNotification } from '../AppNotificationsMonitorContainer';

/**
 * Whether streaming notification cache data actually changed.
 * Cache eviction (current data becoming undefined) is not a change to apply.
 */
export function hasStreamingNotificationDataChanged(
  currentNotifications: Map<string, AppNotification> | undefined,
  originalNotifications: Map<string, AppNotification> | undefined
): boolean {
  if (!currentNotifications || currentNotifications === originalNotifications) {
    return false;
  }

  if (!originalNotifications) {
    return true;
  }

  if (currentNotifications.size !== originalNotifications.size) {
    return true;
  }

  for (const [id, notification] of currentNotifications) {
    const original = originalNotifications.get(id);
    if (!original || original.State !== notification.State || original.Timestamp !== notification.Timestamp) {
      return true;
    }
  }

  return false;
}
